var _style, _defs, _path, _path2, _path3, _path4, _path5, _defs2, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChronicConditions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{clip-path:url(#SVGID_00000182503936419650338920000016299535647901323651_);}\r\n\t.st3{fill:#E86E7B;}\r\n\t.st4{clip-path:url(#SVGID_00000016070597899273586200000002509687523588637341_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000058567284444209443650000008015407940405740436_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125587595342876062430000018331537055374027186_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000125587595342876062430000018331537055374027186_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3 C7,0.4,5.9,0,4.8,0s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2 c0.8-0.8,1.2-1.9,1.2-3s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000096767709680966045130000011380542344796201365_",
    x: 6.4,
    y: 10.1,
    width: 90.1,
    height: 90.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035510876955417797800000002817647242105273269_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096767709680966045130000011380542344796201365_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000035510876955417797800000002817647242105273269_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5,17.6c4.9,0,9.8,1.1,14.6,3c4.5,1.9,8.6,4.9,12.4,8.3H66.9c-1.1,0-1.9,0.4-2.6,1.1c-0.8,0.8-1.1,1.5-1.1,2.6 s0.4,1.9,1.1,2.6c0.8,0.8,1.5,1.1,2.6,1.1h15.4c1.9,0,3.8-0.8,4.9-1.9c1.1-1.5,1.9-3,1.9-4.9V14.2c0-1.1-0.4-1.9-1.1-2.6 s-1.5-1.1-2.6-1.1c-1.1,0-1.9,0.4-2.6,1.1s-1.1,1.5-1.1,2.6v7.9c-6.4-5.6-13.9-9.4-22.2-10.9S42.9,10.5,35,13.5 s-14.6,8.3-19.5,15S7.6,43.1,6.8,51.4c0,0.4,0,1.1,0,1.5s0.4,1.1,0.8,1.5c0.4,0.4,0.8,0.8,1.1,0.8c0.4,0.4,1.1,0.4,1.5,0.4 c0.8,0,1.9-0.4,2.6-0.8c0.8-0.8,1.1-1.5,1.1-2.3c0.8-9.4,5.3-18,12-24.4S42.1,17.6,51.5,17.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3,88.3c-4.9,0.1-9.8-1-14.7-2.8c-4.5-1.8-8.7-4.8-12.5-8.1l11.6-0.1c1.1,0,1.9-0.4,2.6-1.2c0.7-0.8,1.1-1.5,1.1-2.6 c0-1.1-0.4-1.9-1.2-2.6c-0.8-0.7-1.5-1.1-2.6-1.1l-15.4,0.2c-1.9,0-3.7,0.8-4.9,1.9c-1.1,1.5-1.8,3-1.8,4.9l0.2,15.4 c0,1.1,0.4,1.9,1.2,2.6s1.5,1.1,2.6,1.1c1.1,0,1.9-0.4,2.6-1.2c0.7-0.8,1.1-1.5,1.1-2.6l-0.1-7.9c6.4,5.6,14,9.2,22.3,10.6 c8.3,1.4,16.5,0.6,24.4-2.5S82.4,83.8,87.2,77c4.8-6.8,7.7-14.7,8.4-23c0-0.4,0-1.1,0-1.5c0-0.4-0.4-1.1-0.8-1.5 c-0.4-0.4-0.8-0.7-1.1-0.7c-0.4-0.4-1.1-0.4-1.5-0.4c-0.8,0-1.9,0.4-2.6,0.8c-0.7,0.8-1.1,1.5-1.1,2.3c-0.6,9.4-5,18.1-11.7,24.5 C70,84,60.7,88.2,51.3,88.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035510876955417797800000002817647242105273269_)"
    },
    d: "M49.9,36.8c-1.1,0-1.8,0.4-2.5,1.1 c-0.7,0.7-1.1,1.5-1.1,2.5v18.2c0,1.1,0.4,1.8,1.1,2.5l10.9,10.9c0.7,0.7,1.5,1.1,2.5,1.1s1.8-0.4,2.5-1.1 c0.7-0.7,1.1-1.5,1.1-2.5c0-1.1-0.4-1.8-1.1-2.5l-9.8-9.8V40.5c0-1.1-0.4-1.8-1.1-2.5C51.7,37.2,51,36.8,49.9,36.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChronicConditions);
export default __webpack_public_path__ + "static/media/chronicConditions.af758f652b4b1afa7aaaa2fd162e05bd.svg";
export { ForwardRef as ReactComponent };